declare module 'axios' {
  export interface AxiosRequestConfig {
    showError?: boolean;
    includeHeaders?: boolean;
  }
}

import Axios from 'axios';

import { showToast } from '@/src//globalFunction';

const protocol = process.env.PROTOCOL || 'http:';

export const axios = Axios.create({
  baseURL: `${protocol}${process.env.CLOUD_CFO_URL}`,
});

axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config.includeHeaders) {
      return {
        data: response.data,
        headers: response.headers,
      };
    }

    return response.data;
  },
  (error) => {
    if (Axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.config && error.config.showError === false) {
      return Promise.reject(error);
    }

    showToast('error', 'Something went wrong please try again later.');

    return Promise.reject(error);
  }
);
